// LLM generated - Model Claude 4 Sonnet
import useTranslation from 'next-translate/useTranslation';
import { BRANDS } from '~/domains/auth/consts';
import type { PLATFORMS } from '~/domains/auth/consts';
import type { titleStyles } from '~/domains/design-system/Title';
import type { textStyles } from '~/domains/design-system/Text';

import useStyles from './LoginHeader.styles';
import { SSOHeader } from './components/SSOHeader';
import { brandConfigs, getBrandText } from './config/brandConfig';

type LoginHeaderProps = {
  title: string;
  logoSize?: number;
  centered?: boolean;
  titleVariant?: keyof typeof titleStyles;
  copyVariant?: keyof typeof textStyles;
  isLogoVisible?: boolean;
  brand?: BRANDS;
  platform?: PLATFORMS;
  resetSuccess?: string;
  ssoUnifiedLoginAttempted?: boolean;
};

export function LoginHeader({
  logoSize = 25,
  titleVariant = 'display-headline-expanded-xl',
  copyVariant = 'body-large',
  isLogoVisible = true,
  brand,
  platform,
  resetSuccess,
  ssoUnifiedLoginAttempted,
  ...props
}: LoginHeaderProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('auth');

  const currentBrand = brand || BRANDS.SPLASH;
  const brandConfig = brandConfigs[currentBrand];
  const brandText = getBrandText(brand, t);

  // Calculate displaySSOButtons logic for RYP
  const displaySSOButtons =
    brandConfig.supportsSSOHeader &&
    currentBrand === BRANDS.RYP &&
    !ssoUnifiedLoginAttempted &&
    !resetSuccess;

  // If displaySSOButtons is true, render SSO header
  if (displaySSOButtons) {
    return (
      <SSOHeader
        title={props.title}
        brandText={brandText}
        platform={platform}
        titleVariant={titleVariant}
        brand={currentBrand}
        isLogoVisible={isLogoVisible}
      />
    );
  }

  // Get the appropriate renderer for the brand
  const BrandRenderer = brandConfig.renderer;

  // Regular header content inside wrapper
  return (
    <div
      className={`${props.centered ? classes.LoginHeaderWrapperCentered : classes.LoginHeaderWrapper} ${classes.wrapperWithBottomMargin}`}
    >
      <BrandRenderer
        title={props.title}
        brandText={brandText}
        logoSize={logoSize}
        centered={props.centered}
        titleVariant={titleVariant}
        isLogoVisible={isLogoVisible}
        classes={classes}
      />
    </div>
  );
}
